export default __webpack_public_path__ + "static/media/summerchallenge15.92d065db.gif";